import type React from 'react'
import penningSymbol from '../../../assets/symbol.png'

type Props = {
  /** Hand-holding sub-heading shown under the co-branded lockup. */
  subtitle?: string
  children: React.ReactNode
}

// The Penning × Veli co-branded chrome that wraps every screen of the
// migration experience — the public activation pages and (via
// VeliOnboardingShell) the standard onboarding navigator. Presentation only:
// it carries no logic, just the lockup and a calm, explanatory frame so a
// transferring Veli client is never dropped raw into an unfamiliar platform.
const VeliBrandedShell: React.FC<Props> = ({ subtitle, children }) => {
  return (
    <div className="bg-bg-base dark:bg-brand-dark-background min-h-screen flex flex-col items-center px-3 py-10">
      <div className="flex items-center gap-3 mb-2">
        <div className="h-10 w-10 flex items-center justify-center shrink-0 bg-brand-app-menu-hover rounded-full">
          <img src={penningSymbol} alt="Penning logo" className="h-5" />
        </div>
        <span className="text-lg font-semi text-fg-base">Penning</span>
        <span className="text-description text-lg">×</span>
        <span className="text-lg font-semi text-fg-base">Veli</span>
      </div>
      {subtitle && (
        <p className="text-description text-center max-w-md mb-6">{subtitle}</p>
      )}
      <div className="w-full max-w-md">{children}</div>
    </div>
  )
}

export default VeliBrandedShell
